import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ReactNode } from "react";

export type DialogSize = "xl" | "lg" | "sm";

export interface Dialog {
  title: string;
  message: ReactNode;
  size: DialogSize;
}

export interface DialogState {
  dialog: Dialog | null;
}

const initialState: DialogState = {
  dialog: null,
};

export const dialogSlice = createSlice({
  name: "dialog",
  initialState: initialState,
  reducers: {
    showDialog: (_, action: PayloadAction<Dialog>) => {
      return { dialog: action.payload };
    },
    hideDialog: () => {
      return { dialog: null };
    },
  },
});

export const dialogReducer = dialogSlice.reducer;
export const showDialog = dialogSlice.actions.showDialog;
export const hideDialog = dialogSlice.actions.hideDialog;
